<template>
  <div class="pt20">
    <div class="back" @click="back(false)">
      <img src="@/assets/icons/icon_fh.png" alt="" srcset="" />
      <span>{{ $t('semester.back') }}</span>
    </div>
    <h4>{{ id ? $t('semester.editSemester') : $t('semester.createSemester') }}</h4>
    <a-form :form="form" autocomplete="off" layout="vertical">
      <div class="list">
        <a-form-item class="full" :label="$t('semester.semesterName')" :colon="false">
          <a-input
            maxLength="20"
            :placeholder="$t('semester.inputSemesterName')"
            v-decorator="['semesterName', { rules: [{ required: true, message: $t('semester.inputSemesterName') }] }]"
          ></a-input>
        </a-form-item>
        <a-form-item :label="$t('semester.startTime')" :colon="false">
          <a-date-picker
            style="width: 100%;"
            :placeholder="$t('semester.selectStartTime')"
            v-decorator="[
              'startDate',
              {
                rules: [{ required: true, message: $t('semester.selectStartTime') }]
              }
            ]"
          />
        </a-form-item>
      </div>
      <div class="list">
        <a-form-item :label="$t('semester.dailyLessons')" :colon="false">
          <a-input
            maxLength="13"
            type="number"
            :placeholder="$t('semester.inputDailyLessons')"
            v-decorator="[
              'dailyLessons',
              {
                rules: [
                  { required: true, message: $t('semester.inputDailyLessons') },
                  { validator: validateDailyLessons }
                ]
              }
            ]"
          >
          </a-input>
        </a-form-item>
        <a-form-item :label="$t('semester.endTime')" :colon="false">
          <a-date-picker
            style="width: 100%;"
            :placeholder="$t('semester.selectEndTime')"
            v-decorator="[
              'endDate',
              {
                rules: [{ required: true, message: $t('semester.selectEndTime') }, { validator: validateEndDate }]
              }
            ]"
            :disabled-date="disabledEndDate"
          />
        </a-form-item>
      </div>
      <div class="list">
        <a-form-item class="full" :label="$t('semester.lessonTimeRange')" :colon="false">
          <a-time-picker
            style="width: 45%;"
            :placeholder="$t('semester.startTime')"
            format="HH:mm"
            v-decorator="[
              'startTime',
              {
                rules: [{ required: true, message: $t('semester.selectStartTime') }, { validator: validateStartTime }]
              }
            ]"
          >
            <a-icon slot="suffixIcon" type="calendar" />
          </a-time-picker>
          <span style="display: inline-block;width: 10%;text-align: center">-</span>
          <a-time-picker
            style="width: 45%;"
            :placeholder="$t('semester.endTime')"
            format="HH:mm"
            v-decorator="[
              'endTime',
              {
                rules: [{ required: true, message: $t('semester.selectEndTime') }]
              }
            ]"
          >
            <a-icon slot="suffixIcon" type="calendar" />
          </a-time-picker>
        </a-form-item>
      </div>
      <div class="submit-button">
        <a-button type="primary" :loading="submitLoading" @click="handleSubmit">{{ $t('semester.save') }}</a-button>
      </div>
    </a-form>
  </div>
</template>

<script>

import { semesterSave, semesterDetail } from '@/api/admin'
import moment from 'moment'
export default {
  data() {
    return {
      id: undefined,
      form: this.$form.createForm(this),
      submitLoading: false
    }
  },
  methods: {
    validateDailyLessons(rule, value, callback) {
      if (value < 0) {
        callback(this.$t('semester.dailyLessonsNotNegative'))
      } else {
        callback()
      }
    },
    disabledEndDate(current) {
      const startDate = this.form.getFieldValue('startDate')
      return startDate && current && current.isBefore(startDate, 'day')
    },
    validateEndDate(rule, value, callback) {
      const startDate = this.form.getFieldValue('startDate')
      if (value && startDate && value.isBefore(startDate)) {
        callback(this.$t('semester.endTimeNotLessThanStart'))
      } else {
        callback()
      }
    },
    validateStartTime(rule, value, callback) {
      const endTime = this.form.getFieldValue('endTime')
      if (value && endTime && endTime.isBefore(value)) {
        callback(this.$t('semester.endTimeNotLessThanStartTime'))
        return
      }
      callback()
    },
    back() {
      this.$router.push({
        name: 'semesterList'
      })
    },
    handleSubmit(e) {
      if (this.submitLoading) return
      this.submitLoading = true
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          const data = Object.assign(values, {
            id: this.id,
            startDate: values.startDate.format('YYYY-MM-DD 00:00:00'),
            endDate: values.endDate.format('YYYY-MM-DD 23:59:59'),
            lessonTime: values.startTime && values.endTime ? `${values.startTime.format('HH:mm')} ${values.endTime.format('HH:mm')}` : ''
          })
          semesterSave(data).then(res => {
            if (res.code == 200) {
              const successMsg = this.id ? this.$t('semester.editSuccess') : this.$t('semester.createSuccess')
              this.$message.success(successMsg)
              this.$router.push({
                name: 'semesterList'
              })
            }
          }).finally(() => {
            this.submitLoading = false
          })
        } else {
          this.submitLoading = false
        }
      })
    },
    getTeacherDetail() {
      semesterDetail({ id: this.id }).then(res => {
        if (res.code == 200) {
          for (const key in res.data) {
            if (res.data[key] === '0') res.data[key] = undefined
          }
          const data = {
            ...res.data,
            startDate: moment(res.data.startDate),
            endDate: moment(res.data.endDate)
          }
          if (res.data.lessonTime) {
            const [startTime, endTime] = res.data.lessonTime.split(' ')
            data.startTime = moment(startTime, 'HH:mm')
            data.endTime = moment(endTime, 'HH:mm')
          }
          this.form.setFieldsValue(data)
        }
      })
    }
  },
  mounted() {
    this.id = this.$route.query.id || undefined
    if (this.id) {
      this.getTeacherDetail()
    }
  }
}
</script>

<style lang="less" scoped>
h4 {
  font-size: 16px;
  font-weight: 800;
  color: #000000;
  line-height: 22px;
  margin-bottom: 25px;
}

.admin {
  width: 100%;
  cursor: pointer;
  text-align: right;
  margin-bottom: 21px;

  .user-logo {
    width: 26px;
    height: 26px;
    border-radius: 100%;
    margin-right: 12px;
  }

  .down {
    width: 10px;
    margin-left: 5px;
  }
}

/deep/ .ant-input-suffix {
  right: 12px;

  img {
    width: 23px;
    cursor: pointer;
  }
}

.back {
  width: 80px;
  height: 34px;
  display: flex;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  color: #000000;
  border-radius: 25px;
  margin-bottom: 26px;
  align-items: center;
  justify-content: center;
  border: 1px solid #d6d6d6;

  img {
    height: 10px;
    margin-right: 9px;
  }
}

/deep/ .ant-form {
  .title {
    display: flex;
    font-size: 14px;
    font-weight: 600;
    color: #627587;
    line-height: 20px;
    position: relative;
    padding: 12px 17px;
    margin-bottom: 30px;
    align-items: center;
    border-bottom: 1px solid #ededed;

    &::before {
      left: 0;
      content: '';
      width: 4px;
      height: 12px;
      border-radius: 2px;
      position: absolute;
      background: #6b738c;
    }
  }

  .list {
    display: flex;

    .ant-form-item-label label {
      color: #000000;
    }

    .ant-form-item {
      width: 50%;
      padding-left: 45px;

      &:first-child {
        padding-left: 0;
        padding-right: 45px;
      }
    }

    .ant-input-affix-wrapper .ant-input-suffix {
      position: absolute;

      img {
        width: 23px;
        height: 23px;
      }
    }

    .ant-calendar-picker div {
      position: relative;

      .ant-calendar-picker-input {
        margin-right: 0;
        color: #000000;
        border-radius: 4px;
        background: #ffffff;
        border: 1px solid #d8dce0;
      }
    }

    .ant-input,
    .ant-select {
      border-radius: 4px;
      color: #000000;
    }

    .full .ant-input,
    .full .ant-select {
      width: 100%;
      height: 35px;
      color: #000000;
      margin-right: 0;
      border-radius: 4px;
    }

    .ant-input-wrapper.ant-input-group {
      .ant-input {
        border-right: 0;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }

      .ant-input-group-addon {
        background: #fff;
        font-size: 14px;
        font-weight: 400;
        color: #5e7a92;
        line-height: 20px;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
      }
    }
  }

  .submit-button {
    width: 100%;
    // padding-left: 500px;
    text-align: center;
    margin-top: 100px;
  }
}
/deep/ .anticon {
  color: #d5d5d5 !important;
}
</style>
